let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gZjef")).then(() => parcelRequire('a6kDH'));